export const colorShades = [
	"primary-1",
	"primary-2",
	"primary-3",
	"primary-4",
	"primary-5",
	"primary-6",
	"primary-7",
	"primary-8",
	"primary-9",
	"green-1",
	"green-2",
	"green-3",
	"green-4",
	"green-5",
	"green-6",
	"green-7",
	"green-8",
	"green-9",
	"red-1",
	"red-2",
	"red-3",
	"red-4",
	"red-5",
	"red-6",
	"red-7",
	"red-8",
	"red-9",
	"orange-1",
	"orange-2",
	"orange-3",
	"orange-4",
	"orange-5",
	"orange-6",
	"orange-7",
	"orange-8",
	"orange-9",
	"yellow-1",
	"yellow-2",
	"yellow-3",
	"yellow-4",
	"yellow-5",
	"yellow-6",
	"yellow-7",
	"yellow-8",
	"yellow-9",
	"pale-yellow-1",
	"pale-yellow-2",
	"pale-yellow-3",
	"pale-yellow-4",
	"pale-yellow-5",
	"pale-yellow-6",
	"pale-yellow-7",
	"pale-yellow-8",
	"pale-yellow-9",
	"neutral-1",
	"neutral-2",
	"neutral-3",
	"neutral-4",
	"neutral-5",
	"neutral-6",
	"neutral-7",
	"neutral-8",
	"neutral-9",
	"neutral-0",
	"neutral-10",
] as const;

// create a type from the array that is a union of all the elements in the array
export type ColorShade = (typeof colorShades)[number];

export const textColorShadeMapping = {
	"primary-1": "text-primary-1",
	"primary-2": "text-primary-2",
	"primary-3": "text-primary-3",
	"primary-4": "text-primary-4",
	"primary-5": "text-primary-5",
	"primary-6": "text-primary-6",
	"primary-7": "text-primary-7",
	"primary-8": "text-primary-8",
	"primary-9": "text-primary-9",
	"green-1": "text-green-1",
	"green-2": "text-green-2",
	"green-3": "text-green-3",
	"green-4": "text-green-4",
	"green-5": "text-green-5",
	"green-6": "text-green-6",
	"green-7": "text-green-7",
	"green-8": "text-green-8",
	"green-9": "text-green-9",
	"red-1": "text-red-1",
	"red-2": "text-red-2",
	"red-3": "text-red-3",
	"red-4": "text-red-4",
	"red-5": "text-red-5",
	"red-6": "text-red-6",
	"red-7": "text-red-7",
	"red-8": "text-red-8",
	"red-9": "text-red-9",
	"orange-1": "text-orange-1",
	"orange-2": "text-orange-2",
	"orange-3": "text-orange-3",
	"orange-4": "text-orange-4",
	"orange-5": "text-orange-5",
	"orange-6": "text-orange-6",
	"orange-7": "text-orange-7",
	"orange-8": "text-orange-8",
	"orange-9": "text-orange-9",
	"yellow-1": "text-yellow-1",
	"yellow-2": "text-yellow-2",
	"yellow-3": "text-yellow-3",
	"yellow-4": "text-yellow-4",
	"yellow-5": "text-yellow-5",
	"yellow-6": "text-yellow-6",
	"yellow-7": "text-yellow-7",
	"yellow-8": "text-yellow-8",
	"yellow-9": "text-yellow-9",
	"pale-yellow-1": "text-pale-yellow-1",
	"pale-yellow-2": "text-pale-yellow-2",
	"pale-yellow-3": "text-pale-yellow-3",
	"pale-yellow-4": "text-pale-yellow-4",
	"pale-yellow-5": "text-pale-yellow-5",
	"pale-yellow-6": "text-pale-yellow-6",
	"pale-yellow-7": "text-pale-yellow-7",
	"pale-yellow-8": "text-pale-yellow-8",
	"pale-yellow-9": "text-pale-yellow-9",
	"neutral-1": "text-neutral-1",
	"neutral-2": "text-neutral-2",
	"neutral-3": "text-neutral-3",
	"neutral-4": "text-neutral-4",
	"neutral-5": "text-neutral-5",
	"neutral-6": "text-neutral-6",
	"neutral-7": "text-neutral-7",
	"neutral-8": "text-neutral-8",
	"neutral-9": "text-neutral-9",
	"neutral-0": "text-neutral-0",
	"neutral-10": "text-neutral-10",
} as const;

export const textSizesMap = {
	"heading-1": "text-heading-1",
	"heading-2": "text-heading-2",
	"heading-3": "text-heading-3",
	"heading-4": "text-heading-4",
	"heading-5": "text-heading-5",
	"sub-heading": "text-sub-heading",
	"paragraph-1": "text-paragraph-1",
	"paragraph-2": "text-paragraph-2",
	"paragraph-3": "text-paragraph-3",
	caption: "text-caption",
	"extra-small": "text-extra-small",
} as const;

export type TextSize = keyof typeof textSizesMap;

export const fontWeightsMap = {
	regular: "font-regular",
	bold: "font-bold",
	"semi-bold": "font-semi-bold",
} as const;

export type FontWeight = keyof typeof fontWeightsMap;

export type BaseTopColors = "primary" | "green" | "red" | "yellow" | "neutral";
export const baseTopColors = ["primary", "green", "red", "yellow", "neutral"] as const;
